module.exports = __webpack_public_path__ + "static/iphone-mask-f534b7bad077afe8a599b942eff78d72.png";